import $ from 'jquery';

export default class {

    constructor() {
        this.init();
    }

    init() {
        let threshold = 250;

        if ($(window).scrollTop() < threshold) {
            this.setTransparentBG();
        }

        $(window).scroll(() => {
            let scrolling = $(window).scrollTop();

            if (scrolling > threshold) {
                this.resetBannerClasses();
            } else {
                this.setTransparentBG();
            }
        });
    }

    setTransparentBG() {
        $('.banner').addClass('banner-transparent');
        $('.white-logo').removeClass('d-none');
        $('.custom-logo').addClass('d-none');
    }

    resetBannerClasses() {
        $('.banner').removeClass('banner-transparent');
        $('.white-logo').addClass('d-none');
        $('.custom-logo').removeClass('d-none');
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/heroNavScrollHandler.js